import React from 'react'
export default function SocialIcons() {
    return (
        <div className="social-links d-lg-flex d-none">
            <img src={process.env.PUBLIC_URL+"assets/images/socal-icon-1.png"} alt="" />
            <img src={process.env.PUBLIC_URL+"assets/images/socal-icon-2.png"} alt="" />
            <img src={process.env.PUBLIC_URL+"assets/images/socal-icon-3.png"} alt="" />
            <img src={process.env.PUBLIC_URL+"assets/images/socal-icon-4.png"} alt="" />
            <img src={process.env.PUBLIC_URL+"assets/images/socal-icon-5.png"} alt="" />
        </div>
    )
}
